import { Table, TableContainer } from '@material-ui/core';
import { Webhook } from '@nemuru-eng/js-api-client';

import { SliderWarning } from '@/components/modules/Cart/components/OrderLines/components/OrderTable/components/SliderWarning';
import { Body } from '@/components/modules/Webhooks/components/WebhooksTable/components/Body';
import { CustomHeader } from '@/components/shared/components/CustomTable/CustomHeader';
import { useDefaultTable } from '@/components/shared/hooks/useDefaultTable';
import { TableColumn } from '@/config/types';
import { useScreen } from '@/hooks/useScreen';

export type WebhooksTableProps = {
  userId: string;
  webhooks: Webhook[];
  deleteView?: boolean;
};

export const WebhooksTable = ({ userId, webhooks, deleteView }: WebhooksTableProps) => {
  const tableElementId = 'webhooks-table-container';
  const { classes, stickyCellStyle, isScrollable } = useDefaultTable({
    tableElementId,
  });
  const { isMobile } = useScreen();

  const columns = getWebhookTableColumns({ isMobile, deleteView });

  return (
    <>
      <TableContainer id={tableElementId}>
        <Table>
          <CustomHeader tableProps={{ classes, stickyCellStyle }} columns={columns} />
          <Body userId={userId} webhooks={webhooks} tableProps={{ classes, stickyCellStyle }} deleteView={deleteView} />
        </Table>
      </TableContainer>
      {isScrollable && (
        <>
          <SliderWarning />
        </>
      )}
    </>
  );
};

export const getWebhookTableColumns = ({ isMobile, deleteView }: { isMobile: boolean; deleteView?: boolean }) => {
  const columnsDesktop: TableColumn[] = [
    { name: 'created_at', label: 'CREATED_AT_FOR_TABLE', align: 'left', colWidth: '150px' },
    { name: 'url', label: 'WEBHOOK_URL', align: 'left' },
    { name: 'authorization_type', label: 'AUTHORIZATION_TYPE', align: 'left', colWidth: '200px' },
    { name: 'more_actions', label: '', align: 'left', colWidth: '24px' },
  ];

  const columnsMobile: TableColumn[] = columnsDesktop;

  const columnsToHideForDeleteMode = ['more_actions'];

  const hideMoreActionsColumnIfNeeded = (columns, deleteView) => {
    if (deleteView) {
      return columns.filter((column) => !columnsToHideForDeleteMode.includes(column.name));
    }
    return columns;
  };

  return isMobile
    ? hideMoreActionsColumnIfNeeded(columnsMobile, deleteView)
    : hideMoreActionsColumnIfNeeded(columnsDesktop, deleteView);
};
